import {Box, Pagination, PaginationItem, Typography} from "@mui/material";
import React from "react";

const PaginationFrame = ({pagination, handleChange}) => {
    return (
        <Box id="pagination-box" key={pagination.pages} sx={{
            width: "100%",
            maxWidth: 1053,
            margin: "40px",
            display: "flex",
            justifyContent: "center",
        }}>
            <Pagination
                count={pagination.pages}
                page={pagination.currentPage}
                onChange={(p, value) => {handleChange(value)}}
                renderItem={(item) => {
                    // Custom renderer for pagination items
                    if (item.type === "previous") {
                        return (
                            // przycisk poprzedniej strony
                            <PaginationItem
                                {...item}
                                component={Typography}
                                variant="body2"
                                sx={{
                                    color: "#9e9e9e",
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 500,
                                    fontSize: "0.75rem",
                                    "&.Mui-disabled": {
                                        opacity: 1,
                                    },
                                }}
                            >
                                Previous
                            </PaginationItem>
                        );
                    }
                    if (item.type === "next" ) {
                        return (
                            // przycisk następnej strony
                            <PaginationItem
                                {...item}
                                component={Typography}
                                variant="body2"
                                sx={{
                                    color: "#9e9e9e",
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 500,
                                    fontSize: "0.75rem",
                                    "&.Mui-disabled": {
                                        opacity: 1,
                                    },
                                }}
                            >
                                Next
                            </PaginationItem>
                        );
                    }
                    return (
                        // numerki strony
                        <PaginationItem
                            {...item}
                            sx={{
                                borderRadius: "8px",
                                padding: "8px 9px",
                                minWidth: "auto",
                                height: "auto",
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 500,
                                fontSize: "0.75rem",
                                "&.Mui-selected": {
                                    backgroundColor: "primary.main",
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "primary.dark",
                                    },
                                },
                                "&:not(.Mui-selected)": {
                                    backgroundColor: "#e0e0e0",
                                    color: "black",
                                },
                            }}
                        />
                    );
                }}
            />
        </Box>
    );
};

export default PaginationFrame;
